import tw from "tailwind-styled-components";
import Model from "../Model";

const ViewDetail =({setViewDetail, selectedData})=>{

    return(
        <Model width={`w-11/12 max-w-lg`} setOpenModel={setViewDetail}>
            <Wrapper>
                <Title>View Details</Title>
                <div className="flex my-4">
                    <PropertyId>#{selectedData?.id || "N/A"}</PropertyId>
                </div>
                <Column>
                <FirstColumn>
                    <SubHeading>Holder Name</SubHeading>
                    <Paragraph>{selectedData?.holderName || "N/A"}</Paragraph>
                </FirstColumn>
                <SecondColumn>
                    <SubHeading>Account Number</SubHeading>
                    <Paragraph>{selectedData?.accountNum || "N/A"}</Paragraph>
                </SecondColumn> 
                </Column>
                <hr />

                <Column>
                <FirstColumn>
                    <SubHeading>Bank Name</SubHeading>
                    <Paragraph>{selectedData?.bankName || "N/A"}</Paragraph>
                </FirstColumn>
                <SecondColumn>
                    <SubHeading>Ifsc</SubHeading>
                    <Paragraph>{selectedData?.ifsc || "N/A"}</Paragraph>
                </SecondColumn>
                </Column>
                <hr />

                <Column>
                <FirstColumn>
                    <SubHeading>Bank Address</SubHeading>
                    <Paragraph>{selectedData?.bankAddress || "N/A"}</Paragraph>
                </FirstColumn>
                <SecondColumn>
                    <SubHeading>PayuKey</SubHeading>
                    <Paragraph>{selectedData?.payuKey || "N/A"}</Paragraph>
                </SecondColumn>
                </Column>
                <hr />

                <Column>
                <FirstColumn>
                    <SubHeading>PayuMid</SubHeading>
                    <Paragraph>{selectedData?.payuMid || "N/A"}</Paragraph>
                </FirstColumn>
                <SecondColumn>
                    <SubHeading>EaseBuzz</SubHeading>
                    <Paragraph>{selectedData?.easebuzzSubMerchantId || "N/A"}</Paragraph>
                </SecondColumn>
                </Column>
                
            </Wrapper>

        </Model>
    )
}

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;

export default ViewDetail;